import { useEffect } from 'react';

import { Text } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';

import { useTranslation } from 'react-i18next';

export function InfiniteScroll({
  isFetching,
  fetchNextPage,
  hasNextPage,
}: {
  isFetching: boolean;
  fetchNextPage: () => void;
  hasNextPage: boolean;
}) {
  const { ref, entry } = useIntersection({ root: null });
  const { t } = useTranslation('common');

  useEffect(() => {
    if (entry?.isIntersecting && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, entry?.isIntersecting, hasNextPage]);

  if (!hasNextPage) {
    return null;
  }

  if (isFetching) {
    return (
      <Text
        variant="sm"
        sx={theme => ({
          textAlign: 'center',
          marginBottom: theme.spacing['04'],
          fontWeight: 400,
          color: theme.colors.gray[6],
        })}
      >
        {t('loading')}...
      </Text>
    );
  }

  return (
    <Text
      variant="sm"
      ref={ref}
      onClick={() => fetchNextPage()}
      sx={theme => ({
        textAlign: 'center',
        marginBottom: theme.spacing['04'],
        fontWeight: 400,
        color: theme.colors.gray[6],
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'underline',
        },
      })}
    >
      {t('loadMoreResults')}
    </Text>
  );
}
